// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"8fed9078","185":"effdafdd","270":"3633043e","275":"5666178f","400":"5632d21d","534":"821113ce","616":"e72aa69d","666":"af06f16a","721":"1da59a3f","761":"cf3d6fd2","794":"11e96f4f","867":"c99d2ddb","981":"38048e5a","982":"7288a9b1","990":"884902cc"}[chunkId] + ".chunk.js";
};